import { render, staticRenderFns } from "./ApproveConfirmPosition.vue?vue&type=template&id=54fd6e42"
import script from "./ApproveConfirmPosition.vue?vue&type=script&lang=js"
export * from "./ApproveConfirmPosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports